<template>
  <div>
    <!-- start of header -->
    <Header></Header>
    <!-- end of header -->
    
    <!-- start of main section -->
    <MainSection class="main-section"></MainSection>
    <!-- end of main section -->

    <!-- blue container -->
    <!--<blue-container></blue-container>-->
    <!-- End of blue container -->

    <!-- start of footer -->
    <Footer></Footer>
    <!-- end of footer -->
  </div>
</template>

<script>
import Header from './_components/header'
import MainSection from './_components/main_section'
import BlueContainer from './_components/blue_container'
import Footer from './_components/footer'
export default {
  components: {
    Header,
    MainSection,
    BlueContainer,
    Footer
  }
}
</script>


<style scoped>

</style>

